import { BaseIcons } from "../../../lib/icons";
import { FormSchema } from "../../../lib/types";
import { LoginFormFields } from "../types";

export const loginSchema: FormSchema<keyof typeof LoginFormFields>[] = [
  {
    name: LoginFormFields.email,
    label: 'Email',
    type: 'email',
    placeholder: 'Email address',
    isRequired: true,
    icon: BaseIcons.Envelope,
    spellCheck: 'false',
  },
  {
    name: LoginFormFields.password,
    label: 'Password',
    type: 'password',
    placeholder: 'Password',
    isRequired: true,
    icon: BaseIcons.Padlock,
  }
]
